import { matchPath } from "react-router";

export const matchesRoute = (
  routes: string | string[],
  location: Partial<Location>
): boolean => {
  const pathname = location.pathname ?? "";
  const search = location.search ?? "";

  const routeList = Array.isArray(routes) ? routes : [routes];

  return routeList.some((route) => {
    const [expectedPath, expectedQuery] = route.split("?");

    const segments = pathname.split("/").filter(Boolean); // remove leading empty
    for (let i = 0; i < segments.length; i++) {
      const subPath = "/" + segments.slice(i).join("/");

      const matched = matchPath({ path: expectedPath, end: true }, subPath);
      if (!matched) continue;

      if (expectedQuery) {
        const expectedParams = new URLSearchParams(expectedQuery);
        const currentParams = new URLSearchParams(search);

        let allMatch = true;

        expectedParams.forEach((expectedValue, key) => {
          const currentValue = currentParams.get(key);
          if (expectedValue === "*") {
            if (currentValue === null) {
              allMatch = false;
            }
          } else {
            if (currentValue !== expectedValue) {
              allMatch = false;
            }
          }
        });

        if (!allMatch) continue;
      }

      return true;
    }

    return false;
  });
};
